import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountState } from '@state/account/state';
import { map, Observable } from 'rxjs';
import { Approval } from '@shared/modules/approvals/approvals.types';

@Injectable({
  providedIn: 'root',
})
export class TaskApprovalsService {
  private httpClient = inject(HttpClient);
  private store = inject(Store);
  private accountId = this.store.selectSnapshot(AccountState.getAccountId);

  private shallowUrl = 'tasks';

  private buildParams(taskListId: number): Record<string, any> {
    return {
      account_id: this.accountId,
      task_list_id: taskListId,
    };
  }

  addApproverToTask(taskListId: number, taskId: number, approval: Approval): Observable<Approval> {
    const params = this.buildParams(taskListId);
    const payload = {
      approval: {
        assigned_user_id: approval.assigned_user.id,
        task_id: taskId,
      },
    };

    return this.httpClient
      .post<any>(`${this.shallowUrl}/${taskId}/approvals`, payload, { params })
      .pipe(map((response) => response.approval));
  }

  removeApproverFromTask(taskListId: number, taskId: number, approval: Approval): Observable<Approval> {
    const params = this.buildParams(taskListId);

    return this.httpClient
      .delete<any>(`${this.shallowUrl}/${taskId}/approvals/${approval.id}`, { params })
      .pipe(map((response) => response.approval));
  }

  notifyTaskApprover(taskListId: number, taskId: number, approval: Approval): Observable<Approval> {
    const params = this.buildParams(taskListId);

    return this.httpClient
      .post<any>(`${this.shallowUrl}/${taskId}/approvals/${approval.id}/notify`, { approval }, { params })
      .pipe(map((response) => response.approval));
  }

  notifyAllTaskApprovers(taskListId: number, taskId: number): Observable<any> {
    const params = this.buildParams(taskListId);

    return this.httpClient.post<any>(`${this.shallowUrl}/${taskId}/approvals/notify`, {}, { params });
  }
}
